import script from "./DetailTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailTable.vue?vue&type=script&setup=true&lang=ts"

import "./DetailTable.vue?vue&type=style&index=0&id=1ef95813&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef95813"]])

export default __exports__